import { __awaiter } from "tslib";
import { _Folder, } from "../folders/types.js";
import { SharingRole, } from "./types.js";
_Folder.prototype.shareWith = function (loginNames, role = SharingRole.View, requireSignin = false, shareEverything = false, emailData) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.shareWith(loginNames, role, requireSignin, shareEverything, emailData);
    });
};
_Folder.prototype.getShareLink = function (kind, expiration = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.getShareLink(kind, expiration);
    });
};
_Folder.prototype.checkSharingPermissions = function (recipients) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.checkSharingPermissions(recipients);
    });
};
_Folder.prototype.getSharingInformation = function (request, expands) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.getSharingInformation(request, expands);
    });
};
_Folder.prototype.getObjectSharingSettings = function (useSimplifiedRoles = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.getObjectSharingSettings(useSimplifiedRoles);
    });
};
_Folder.prototype.unshare = function () {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.unshare();
    });
};
_Folder.prototype.deleteSharingLinkByKind = function (kind) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.deleteSharingLinkByKind(kind);
    });
};
_Folder.prototype.unshareLink = function (kind, shareId) {
    return __awaiter(this, void 0, void 0, function* () {
        const dependency = this.addBatchDependency();
        const shareable = yield this.getShareable();
        dependency();
        return shareable.unshareLink(kind, shareId);
    });
};
//# sourceMappingURL=folder.js.map